import { Component, Input } from "@angular/core";
import { tryParseDate } from "../../../../../services/utils/timestamp.utils";
import { ApiOrder } from "../../../../../services/order/order-api.service";
import { NavigationService } from "../../../../../services/navigation/navigation.service";

@Component({
  selector: "rc-mobile-order-table",
  templateUrl: "./mobile-order-table.component.html",
  styleUrls: ["./mobile-order-table.component.scss"],
  standalone: false,
})
export class MobileOrderTableComponent {
  @Input() public orders: ApiOrder[];
  @Input() public searchString: string | undefined;

  constructor(public readonly navigationService: NavigationService) {}

  public readonly tryParseDate = tryParseDate;
}
